import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { getAllPartenaires } from "../../services/partenairesServices";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./PartenairesCarousel.css"; // Assurez-vous de créer ce fichier CSS pour les styles personnalisés

const PartenairesCarousel = () => {
  const [partenaires, setPartenaires] = useState([]);

  useEffect(() => {
    const fetchPartenaires = async () => {
      try {
        const allPartenaires = await getAllPartenaires();
        const activePartenaires = allPartenaires.filter((p) => p.is_active);
        setPartenaires(activePartenaires);
      } catch (error) {
        console.error("Erreur lors de la récupération des partenaires", error);
      }
    };

    fetchPartenaires();
  }, []);

  let settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Ajuster les paramètres si un seul partenaire est présent
  if (partenaires.length === 1) {
    settings = {
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
    };
  }

  if (partenaires.length === 0) {
    return null; // Ne rien afficher si pas de partenaires actifs
  }

  return (
    <div className="container mx-auto py-8">
      <h2 className="text-3xl font-extrabold mb-4 text-primary mx-auto text-center font-satoshi uppercase">
        Nos Partenaires
      </h2>
      <Slider {...settings}>
        {partenaires.map((partenaire) => (
          <div key={partenaire.id} className="p-4">
            {partenaire.is_detail ? (
              <Link to={`/partenaires/${encodeURIComponent(partenaire.nom)}`}>
                <div className="bg-slate-100 dark:bg-slate-500 shadow-md rounded-lg p-4 flex flex-col items-center">
                  <img
                    src={partenaire.photo_url}
                    alt={partenaire.nom}
                    className="w-full h-32 object-contain mb-4"
                  />
                  <h3 className="text-normal font-semibold text-center">
                    {partenaire.nom}
                  </h3>
                </div>
              </Link>
            ) : (
              <a
                href={partenaire.link_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="bg-slate-100 dark:bg-slate-500 shadow-md rounded-lg p-4 flex flex-col items-center">
                  <img
                    src={partenaire.photo_url}
                    alt={partenaire.nom}
                    className="w-full h-32 object-contain mb-4"
                  />
                  <h3 className="text-normal font-semibold text-center">
                    {partenaire.nom}
                  </h3>
                </div>
              </a>
            )}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default PartenairesCarousel;
